import { PhoneOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    getAgentWithoutTeamThunk,
    postUserTeamAddUserThunk,
} from "tm-shared/api";
import { UserRole } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";

import {
    TeamMemberBlock,
    UserInfoDescriptionLink,
    UserInfoTitle,
} from "./Styled";

function AddMemberToTeam() {
    const dispatch = useAppDispatch();
    const { freeMembers } = useAppSelector((state) => state.hr);
    const { managerId, managerRole } = useParams();

    const roleToSearch =
        managerRole === UserRole.Svm ? UserRole.Md : UserRole.Ta;

    const handleAddMember = async (userId) => {
        try {
            await dispatch(
                postUserTeamAddUserThunk({
                    managerId,
                    userId,
                }),
            ).unwrap();

            dispatch(
                getAgentWithoutTeamThunk({
                    role: roleToSearch,
                }),
            );
        } catch (err) {
            return;
        }
    };

    useEffect(() => {
        dispatch(getAgentWithoutTeamThunk({ role: roleToSearch }));
    }, [dispatch]);

    return (
        <>
            <Meta title="Profile" />
            <Header title="Додати у команду" back />
            <MainContainer>
                {freeMembers &&
                    Object.values(freeMembers)?.map((member) => (
                        <TeamMemberBlock key={member?.userId}>
                            <FlexContainer
                                width="60%"
                                justifyContent="flex-start"
                                gap="8px"
                            >
                                <Avatar
                                    style={{ width: "42px" }}
                                    icon={<UserOutlined />}
                                />
                                <FlexContainer
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    gap="8px"
                                    width="100%"
                                >
                                    <UserInfoTitle>
                                        {member?.fullName}
                                    </UserInfoTitle>
                                    <FlexContainer
                                        width="100%"
                                        justifyContent="space-between"
                                    >
                                        <UserInfoDescriptionLink
                                            href={member?.phone}
                                        >
                                            {member?.phone}
                                        </UserInfoDescriptionLink>
                                        <UserInfoDescriptionLink
                                            href={member?.phone}
                                        >
                                            <PhoneOutlined />
                                        </UserInfoDescriptionLink>
                                    </FlexContainer>
                                </FlexContainer>
                            </FlexContainer>
                            <Avatar
                                style={{
                                    backgroundColor: "#49AA19",
                                    cursor: "pointer",
                                }}
                                size={40}
                                icon={<PlusOutlined />}
                                onClick={() => handleAddMember(member?.userId)}
                            />
                        </TeamMemberBlock>
                    ))}
            </MainContainer>
        </>
    );
}

export default AddMemberToTeam;
